// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find_face {
  min-height: 80vh;
  overflow: auto;
}
.find_face::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.find_face::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.find_face::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .find_face::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .find_face::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .find_face::-webkit-scrollbar-track {
    background: white;
  }
}
.find_face .face_lookup {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  margin: 2vh auto;
}
.find_face .face_lookup input {
  height: 4vh;
  width: 300px;
  border-radius: 5px;
}
.find_face .face_lookup .lookup_btn {
  background-color: #151042;
  width: 150px;
}
@media (max-width: 1000px) {
  .find_face .face_lookup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
  }
  .find_face .face_lookup input {
    width: 95vw;
  }
  .find_face .face_lookup .lookup_btn {
    background-color: #151042;
    width: 95vw;
  }
}
.find_face .alert_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0;
  margin: 2vh auto;
  height: 4vh;
}
.find_face .alert_section .alert_box {
  background-color: #151042;
  color: #fff;
  font-weight: 700;
  margin: 0;
  padding: 0;
  width: 300px;
  text-align: center;
  justify-content: center;
}
.find_face .details_section .img_container {
  min-height: 350px;
  max-height: 350px;
  border: 1px solid #000;
  border-radius: 5px;
  width: 350px;
  margin: 0 auto;
  margin-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.find_face .details_section .img_container .face_image {
  width: 300px;
  max-width: 300px;
  max-height: 300px;
  border-radius: 5px;
}
@media (max-width: 1000px) {
  .find_face .details_section .img_container .face_image {
    width: 95vw;
    max-width: 95vw;
  }
}
.find_face .details_section .header_details {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
}
.find_face .details_section .header_details h2 {
  color: #151042;
  font-weight: 700;
  font-size: 1.1rem;
  border: 3px solid #151042;
  width: 300px;
  border-radius: 5px;
  margin: 0;
  height: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}
.find_face .details_section .header_details h2 span {
  color: #000;
}
.find_face .details_section .header_details h2 .update_btn {
  height: 3.5vh;
}
.find_face .details_section .header_details button {
  width: 306px;
  height: 4.2vh;
  background-color: #ffe169;
  color: #151042;
  font-weight: 700;
}
@media (max-width: 1000px) {
  .find_face .details_section .header_details h2,
  .find_face .details_section .header_details button {
    width: 95vw;
  }
}
@media (max-width: 1000px) {
  .find_face .details_section .face_info_table td:nth-of-type(1):before {
    content: "Date/Time";
  }
  .find_face .details_section .face_info_table td:nth-of-type(2):before {
    content: "Store";
  }
  .find_face .details_section .face_info_table td:nth-of-type(3):before {
    content: "Logs";
  }
}
.find_face .details_section .face_info_table .log_btn {
  background-color: #151042;
}

.logs_modal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.logs_modal h2 {
  margin: 0;
}
.logs_modal .table_container {
  overflow-y: auto;
}
.logs_modal .table_container table {
  width: 100%;
}
@media (max-width: 1000px) {
  .logs_modal .table_container table td:nth-of-type(1):before {
    content: "Note";
  }
  .logs_modal .table_container table td:nth-of-type(2):before {
    content: "Date/Time";
  }
}
.logs_modal button {
  width: 100%;
}

.update_dialog {
  width: 300px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.update_dialog .update_select select {
  height: 4vh;
  width: 300px;
  border-radius: 5px;
}
.update_dialog .btn_section {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  width: 100%;
}
.update_dialog .btn_section button {
  width: 49%;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/findface.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AC4DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAExB;AC6DI;EACI,mBAxDO;ADHf;AC8DI;EACI,mBAbe;AD/CvB;AAPI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAW1B;ECkDE;IACI,gBA9DA;EDcN;ECmDE;IACI,iBAbe;EDpCrB;AACF;AAfI;ECmBA,aAAA;EACA,uBDnBkB;ECoBlB,mBDpB0B;ECqB1B,mBDrBkC;ECsBlC,SDtBuC;EACnC,gBAAA;AAqBR;AAnBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAqBZ;AAlBQ;EACI,yBCTO;EDUP,YAAA;AAoBZ;AAjBQ;EAfJ;ICmBA,aAAA;IACA,uBDJsB;ICKtB,mBDL8B;ICM9B,sBDNsC;ICOtC,SDP8C;EAwBhD;EAvBU;IACI,WAAA;EAyBd;EAvBU;IACI,yBCnBG;IDoBH,WAAA;EAyBd;AACF;AAtBI;ECPA,aAAA;EACA,uBDOkB;ECNlB,mBDM0B;ECL1B,sBDKkC;ECJlC,MDI0C;EACtC,gBAAA;EACA,WAAA;AA4BR;AA3BQ;EACI,yBC7BO;ED8BP,WCnCJ;EDoCI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AA6BZ;AAxBQ;EACI,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA0BZ;AAzBY;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA2BhB;AAzBgB;EANJ;IAOQ,WAAA;IACA,eAAA;EA4BlB;AACF;AAxBQ;EChDJ,aAAA;EACA,uBDgDsB;EC/CtB,mBD+C8B;EC9C9B,mBD8CsC;EC7CtC,SD6C2C;EACnC,eAAA;AA8BZ;AA5BY;EACI,cCtEG;EDuEH,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EC5DZ,aAAA;EACA,uBD6D0B;EC5D1B,mBD4DkC;EC3DlC,mBAJsD;EAKtD,SALiE;ADgGrE;AAhCgB;EACI,WCrFZ;ADuHR;AAhCgB;EACI,aAAA;AAkCpB;AA/BY;EACI,YAAA;EACA,aAAA;EACA,yBCvFC;EDwFD,cC3FG;ED4FH,gBAAA;AAiChB;AA/BY;EACI;;IAEI,WAAA;EAiClB;AACF;AA5BY;EACI;IACI,oBAAA;EA8BlB;EA5Bc;IACI,gBAAA;EA8BlB;EA5Bc;IACI,eAAA;EA8BlB;AACF;AA3BY;EACI,yBCpHG;ADiJnB;;AAvBA;ECzGI,aAAA;EACA,uBDyGc;ECxGd,mBDwGsB;ECvGtB,sBDuG8B;ECtG9B,SDsGsC;AA8B1C;AA7BI;EACI,SAAA;AA+BR;AA7BI;EACI,gBAAA;AA+BR;AA7BQ;EACI,WAAA;AA+BZ;AA9BY;EACI;IACI,eAAA;EAgClB;EA9Bc;IACI,oBAAA;EAgClB;AACF;AA5BI;EACI,WAAA;AA8BR;;AA1BA;EACI,YAAA;EACA,aAAA;ECpIA,aAAA;EACA,uBDoIc;ECnId,mBDmIsB;EClItB,sBDkI8B;ECjI9B,SDiIsC;AAiC1C;AA9BQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAgCZ;AA5BI;EC/IA,aAAA;EACA,6BD+IkB;EC9IlB,mBD8IgC;EC7IhC,mBD6IwC;EC5IxC,SD4I6C;EACzC,WAAA;AAkCR;AAjCQ;EACI,UAAA;AAmCZ","sourcesContent":["@import \"../../variables.scss\";\n\n.find_face {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .face_lookup {\n        @include flex(center, center, row, 10px);\n        margin: 2vh auto;\n\n        input {\n            height: 4vh;\n            width: 300px;\n            border-radius: 5px;\n        }\n\n        .lookup_btn {\n            background-color: $nitrocamDarkBlue;\n            width: 150px;\n        }\n\n        @media (max-width: $tablet) {\n            @include flex(center, center, column, 10px);\n            input {\n                width: 95vw;\n            }\n            .lookup_btn {\n                background-color: $nitrocamDarkBlue;\n                width: 95vw;\n            }\n        }\n    }\n    .alert_section {\n        @include flex(center, center, column, 0);\n        margin: 2vh auto;\n        height: 4vh;\n        .alert_box {\n            background-color: $nitrocamDarkBlue;\n            color: $white;\n            font-weight: 700;\n            margin: 0;\n            padding: 0;\n            width: 300px;\n            text-align: center;\n            justify-content: center;\n        }\n    }\n\n    .details_section {\n        .img_container {\n            min-height: 350px;\n            max-height: 350px;\n            border: 1px solid #000;\n            border-radius: 5px;\n            width: 350px;\n            margin: 0 auto;\n            margin-bottom: 2vh;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            .face_image {\n                width: 300px;\n                max-width: 300px;\n                max-height: 300px;\n                border-radius: 5px;\n\n                @media (max-width: $tablet) {\n                    width: 95vw;\n                    max-width: 95vw;\n                }\n            }\n        }\n\n        .header_details {\n            @include flex(center, center, row, 10px);\n            flex-wrap: wrap;\n\n            h2 {\n                color: $nitrocamDarkBlue;\n                font-weight: 700;\n                font-size: 1.1rem;\n                border: 3px solid $nitrocamDarkBlue;\n                width: 300px;\n                border-radius: 5px;\n                margin: 0;\n                height: 4vh;\n\n                @include flex(center, center);\n                span {\n                    color: $black;\n                }\n                .update_btn {\n                    height: 3.5vh;\n                }\n            }\n            button {\n                width: 306px;\n                height: 4.2vh;\n                background-color: $nitrocamYellow;\n                color: $nitrocamDarkBlue;\n                font-weight: 700;\n            }\n            @media (max-width: $tablet) {\n                h2,\n                button {\n                    width: 95vw;\n                }\n            }\n        }\n\n        .face_info_table {\n            @media (max-width: $tablet) {\n                td:nth-of-type(1):before {\n                    content: \"Date/Time\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Store\";\n                }\n                td:nth-of-type(3):before {\n                    content: \"Logs\";\n                }\n            }\n\n            .log_btn {\n                background-color: $nitrocamDarkBlue;\n            }\n        }\n    }\n}\n\n.logs_modal {\n    @include flex(center, center, column, 10px);\n    h2 {\n        margin: 0;\n    }\n    .table_container {\n        overflow-y: auto;\n\n        table {\n            width: 100%;\n            @media (max-width: $tablet) {\n                td:nth-of-type(1):before {\n                    content: \"Note\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Date/Time\";\n                }\n            }\n        }\n    }\n    button {\n        width: 100%;\n    }\n}\n\n.update_dialog {\n    width: 300px;\n    padding: 10px;\n    @include flex(center, center, column, 10px);\n\n    .update_select {\n        select {\n            height: 4vh;\n            width: 300px;\n            border-radius: 5px;\n        }\n    }\n\n    .btn_section {\n        @include flex(space-evenly, center, row, 10px);\n        width: 100%;\n        button {\n            width: 49%;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
